(function () {
  const PRODUCT_SELECTOR = ".globo_color_swatch_bundle_quantity_break";

  const COLOR_SELECT_SELECTOR = [
    '.gcw-quantity-break__offer-variant-select[data-name="Kleur"]',
    '.gcw-quantity-break__offer-variant-select[data-name="Color"]',
    '.gcw-quantity-break__offer-variant-select[data-name="Farbe"]'
  ].join(",");

  const COLOR_IMAGES = {
    WHITE: "https://zone2sportswear.com/cdn/shop/files/schuin_-_w-2.jpg?v=1765240845&width=150&height=150",
    BLACK: "https://zone2sportswear.com/cdn/shop/files/schuin_-_z.jpg?v=1766971125&width=150&height=150"
  };

  const COLOR_ALIASES = {
    WIT: "WHITE",
    WHITE: "WHITE",
    WEISS: "WHITE",
    WEIẞ: "WHITE",
    WEIß: "WHITE",
    "WEI\u00DF": "WHITE",

    ZWART: "BLACK",
    BLACK: "BLACK",
    SCHWARZ: "BLACK"
  };

  function normalizeColorValue(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .replace(/ß/g, "SS")
      .replace(/ẞ/g, "SS");
  }

  function getColorImage(value) {
    const normalizedValue = normalizeColorValue(value);
    const colorKey = COLOR_ALIASES[normalizedValue];

    return COLOR_IMAGES[colorKey] || "";
  }


  function closeAllDropdowns(exceptDropdown) {
    document.querySelectorAll(".z2-color-dropdown.is-open").forEach(function (dropdown) {
      if (dropdown !== exceptDropdown) {
        dropdown.classList.remove("is-open");
      }
    });
  }

  function buildColorDropdown(select) {
    if (select.dataset.z2ColorDropdownReady === "1") return;

    const dropdown = document.createElement("div");
    dropdown.className = "z2-color-dropdown";

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "z2-color-dropdown__trigger";

    const optionList = document.createElement("div");
    optionList.className = "z2-color-dropdown__options";

    function renderTrigger() {
      const value = select.value;
      const image = getColorImage(value);

    trigger.innerHTML = `
    <span class="z2-color-dropdown__selected">
        <img class="z2-color-dropdown__image" src="${image}" alt="${value}">
        <span>${value}</span>
    </span>
    `;
    }

    Array.from(select.options).forEach(function (option) {
      const value = option.value;
      const image = getColorImage(value);

      const optionButton = document.createElement("button");
      optionButton.type = "button";
      optionButton.className = "z2-color-dropdown__option";
      optionButton.dataset.value = value;

      optionButton.innerHTML = `
        <img class="z2-color-dropdown__image" src="${image}" alt="${value}">
        <span>${value}</span>
      `;

      optionButton.addEventListener("click", function () {
        select.value = value;

        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));

        renderTrigger();
        dropdown.classList.remove("is-open");
      });

      optionList.appendChild(optionButton);
    });

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = dropdown.classList.contains("is-open");

      closeAllDropdowns(dropdown);

      if (!isOpen) {
        dropdown.classList.add("is-open");
      }
    });

    dropdown.appendChild(trigger);
    dropdown.appendChild(optionList);

    select.insertAdjacentElement("afterend", dropdown);

    renderTrigger();

    select.dataset.z2ColorDropdownReady = "1";
  }

  function initColorDropdowns() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block
        .querySelectorAll(COLOR_SELECT_SELECTOR)
        .forEach(buildColorDropdown);
    });
  }

  function addVariantNumberSwatches() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".gcw-quantity-break__offer-variant__content").forEach(function (variantContent) {
        const numberBox = variantContent.querySelector(".gcw-quantity-break__offer-variant-number");
        const colorSelect = variantContent.querySelector(COLOR_SELECT_SELECTOR);

        if (!numberBox || !colorSelect) return;

        let image = numberBox.querySelector(".z2-variant-number-swatch");

        if (!image) {
          image = document.createElement("img");
          image.className = "z2-variant-number-swatch";
          numberBox.appendChild(image);
        }

        function updateImage() {
          const color = colorSelect.value;
          image.src = getColorImage(color);
          image.alt = color;
        }

        updateImage();

        if (!colorSelect.dataset.z2SwatchBound) {
          colorSelect.addEventListener("change", updateImage);
          colorSelect.dataset.z2SwatchBound = "1";
        }
      });
    });
  }

  function updateFreeGiftTitles() {
  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    block.querySelectorAll(".free-gift--title").forEach(function (title) {
      const originalTitle = title.textContent.trim();

      if (!originalTitle) return;
      if (originalTitle.toUpperCase().startsWith("+ GRATIS")) return;

      title.textContent = "+ GRATIS " + originalTitle;
    });
  });
}



    function addExtraLabelsToTwoGlasses() {
      document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
        block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
          const title = offer.querySelector(".gcw-quantity-break__offer-title");
          const firstLine = offer.querySelector(".gcw-quantity-break__offer-first-line");

          if (!title || !firstLine) return;

          const titleText = title.textContent.trim().toUpperCase();

          if (titleText !== "2 BRILLEN") return;

          const labelsToAdd = ["GRATIS CLEANING KIT"];

          labelsToAdd.forEach(function (labelText) {
            if (firstLine.querySelector('[data-z2-extra-label="' + labelText + '"]')) return;

            const label = document.createElement("span");
            label.className = "gcw-quantity-break__offer-label";
            label.dataset.z2ExtraLabel = labelText;
            label.textContent = labelText;

            firstLine.appendChild(label);
          });
        });
      });
    }

    function wrapTwoGlassesLabels() {
      document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
        block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
          const title = offer.querySelector(".gcw-quantity-break__offer-title");
          const firstLine = offer.querySelector(".gcw-quantity-break__offer-first-line");

          if (!title || !firstLine) return;

          const titleText = title.textContent.trim().toUpperCase();

          if (titleText !== "2 BRILLEN") return;

          if (firstLine.querySelector(".z2-offer-labels-wrap")) return;

          const labels = Array.from(firstLine.querySelectorAll(".gcw-quantity-break__offer-label"));

          if (!labels.length) return;

          const labelWrap = document.createElement("span");
          labelWrap.className = "z2-offer-labels-wrap";

          labels.forEach(function (label) {
            labelWrap.appendChild(label);
          });

          title.insertAdjacentElement("afterend", labelWrap);
        });
      });
    }


        


function hideNullFreeGiftText() {
  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    block.querySelectorAll(".free-gift--text").forEach(function (textEl) {
      const text = textEl.textContent.trim().toLowerCase();

      if (text === "null") {
        textEl.style.display = "none";
      }
    });
  });
}

function updateHardcodedBundlePricing() {
  const SINGLE_GLASSES_PRICE = "49,95";
  const DEAL_PRICE_PER_GLASSES = "42,46";

  document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
    const singleOffer = block.querySelector('.gcw-quantity-break__offer[data-offer-index="0"]');
    const dealOffer = block.querySelector('.gcw-quantity-break__offer[data-offer-index="1"]');

    if (singleOffer) {
      const price = singleOffer.querySelector(".gcw-quantity-break__offer-price");
      const comparePrice = singleOffer.querySelector(".gcw-quantity-break__offer-compare-price");

      setTextIfChanged(price, SINGLE_GLASSES_PRICE);

      if (comparePrice) {
        setTextIfChanged(comparePrice, "");
        comparePrice.style.display = "none";
      }
    }

    if (dealOffer) {
      const price = dealOffer.querySelector(".gcw-quantity-break__offer-price");
      const comparePrice = dealOffer.querySelector(".gcw-quantity-break__offer-compare-price");

      setTextIfChanged(price, DEAL_PRICE_PER_GLASSES);

      if (comparePrice) {
        setTextIfChanged(comparePrice, SINGLE_GLASSES_PRICE);
        comparePrice.style.display = "";
      }
    }
  });
}

function setTextIfChanged(element, value) {
  if (!element) return;

  if (element.textContent.trim() !== value) {
    element.textContent = value;
  }
}


  function initGlassesBundle() {
    initColorDropdowns();
    addVariantNumberSwatches();
    updateFreeGiftTitles();
    hideNullFreeGiftText();

    addExtraLabelsToTwoGlasses();
    wrapTwoGlassesLabels();
    updateHardcodedBundlePricing();
  }

  document.addEventListener("click", function () {
    closeAllDropdowns();
  });

initGlassesBundle();

const observer = new MutationObserver(initGlassesBundle);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();




(function () {
  function findSizeGuideToggle() {
    const nodes = Array.from(document.querySelectorAll('[class*="__ss_size_guide_2_"]'));

    for (const el of nodes) {
      if (typeof el.className === "string" && el.className.includes("size-toggle-")) {
        return el;
      }
    }

    return null;
  }

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-z2-open-size-guide]");
    if (!openBtn) return;

    e.preventDefault();

    const toggle = findSizeGuideToggle();

    if (toggle) {
      toggle.click();
    }
  });
})();